
/* Existing homepage beige caption logic only; PLP headings retain standard dark text.
   Works on mobile and desktop; does not touch image hover, swatches, PDP or variant navigation. */
(function () {
  "use strict";
  if (window.__sleeperBeigeCaptionTest) return;
  window.__sleeperBeigeCaptionTest = true;

  function beige(r, g, b) {
    return r >= 163 && g >= 119 && b >= 88 &&
      r > g + 7 && g > b + 8 && r - b >= 26 &&
      r - b <= 126 && g - b <= 87;
  }
  function inspect(card) {
    if (card.dataset.sleeperBeigeChecked === "yes") return;
    card.dataset.sleeperBeigeChecked = "yes";
    var img = card.querySelector(".card__media .media img.motion-reduce, .card__media img");
    if (!img) return;
    var src = img.dataset.sleeperOriginalSrc || img.getAttribute("src");
    if (!src) return;
    var photo = new Image();
    photo.crossOrigin = "anonymous";
    photo.onload = function () {
      try {
        var canvas = document.createElement("canvas");
        canvas.width = 32;
        canvas.height = 48;
        var ctx = canvas.getContext("2d", { willReadFrequently: true });
        if (!ctx) return;
        ctx.drawImage(photo, 0, 0, 32, 48);
        var count = 0;
        [3, 5, 7, 24, 27, 29].forEach(function (x) {
          [38, 42, 45].forEach(function (y) {
            var c = ctx.getImageData(x, y, 1, 1).data;
            if (beige(c[0], c[1], c[2])) count++;
          });
        });
        if (count >= 10) card.classList.add("sleeper-beige-caption");
      } catch (_) {
        /* Preserve the existing text color if photo pixels cannot be read. */
      }
    };
    photo.src = src;
  }
  function scan() {
    document.querySelectorAll(
      ".sleeper-home-beige-test .product-card-wrapper"
    ).forEach(inspect);
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scan);
  } else {
    scan();
  }
  var queued = false;
  new MutationObserver(function (changes) {
    if (queued || !changes.some(function (change) { return change.addedNodes.length; })) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      scan();
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
